import type { ReactNode } from 'react';

interface FormFieldProps {
  id: string;
  label: string;
  error?: string;
  hint?: string;
  required?: boolean;
  children: ReactNode;
}

export function FormField({ id, label, error, hint, required = false, children }: FormFieldProps) {
  const hintId = hint ? `${id}-hint` : undefined;
  const errorId = error ? `${id}-error` : undefined;
  return (
    <div className="ui-formField">
      <label className="ui-formFieldLabel" htmlFor={id}>{label}{required && <span aria-hidden="true"> *</span>}</label>
      {hint && <div className="ui-formFieldHint" id={hintId}>{hint}</div>}
      <div aria-describedby={[hintId, errorId].filter(Boolean).join(' ') || undefined}>{children}</div>
      {error && <div className="ui-formFieldError" id={errorId} role="alert">{error}</div>}
    </div>
  );
}
